

require('./styles');

var _logger = require('xo-beaver/dist/logger');

define(['squid/index', 'text!./template.html'], function (squid, template) {

    squid.module('xo-banner.directive', ['squid']).directive('xoBanner', function () {
        return {
            scope: {
                bannerImage: '='
            },
            template: template,
            transclude: true,
            link: function link(scope, element) {
                var imageType = 'default';
                var deregisterWatcher = scope.$watch('bannerImage', function () {
                    if (scope.bannerImage) {
                        var elem = document.getElementById('banner-picture');
                        if (elem) {
                            elem.style.backgroundImage = 'url("' + scope.bannerImage + '")';
                            imageType = 'user';
                        }
                        deregisterWatcher(); // $watch returns a deregister function
                        deregisterWatcher = 'deregisterd'; // converting deregisterWatcher into a non-function
                    }

                    // Todo : remove logger from ui once proven stable on production
                    _logger.$logger.info('xoBanner', {
                        'watcher_enabled': angular.isFunction(deregisterWatcher),
                        'image_type': imageType
                    });
                });
            }
        };
    });
});

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/banner/directive.js
// module id = ./components/xo-ui-components/src/banner/directive.js
// module chunks = 1